/**
 * Resolves once the Login response has landed in the store, or when the cap expires.
 *
 * silentLogin dispatches updateUserData when Login returns, so a non-empty
 * userSlice.userData is the signal. Nothing is dispatched when Login *fails* — that
 * path navigates to /partner-error and unmounts whoever was waiting — so the cap is
 * what stops a hanging request holding a screen open indefinitely. On expiry the
 * caller simply proceeds with whatever it has, i.e. the behaviour it had before it
 * started waiting.
 *
 * Subscribes rather than polls, and reads the live store rather than a captured value.
 *
 * @param {Object} store - the redux store (useStore())
 * @param {number} capMs - give up after this long
 * @returns {Promise<boolean>} true if Login landed, false if the cap expired first
 */
export default function waitForLogin(store, capMs) {
  const hasUserData = () => Object.keys(store.getState().userSlice.userData || {}).length > 0;

  if (hasUserData()) return Promise.resolve(true);

  return new Promise((resolve) => {
    const settle = (landed) => {
      clearTimeout(timer);
      unsubscribe();
      resolve(landed);
    };

    const timer = setTimeout(() => settle(false), capMs);
    const unsubscribe = store.subscribe(() => {
      if (hasUserData()) settle(true);
    });
  });
}
